var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThailand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4551C24.8366 32.4551 32 25.2916 32 16.4551C32 7.61852 24.8366 0.455078 16 0.455078C7.16344 0.455078 0 7.61852 0 16.4551C0 25.2916 7.16344 32.4551 16 32.4551Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 10.8899H0.995188C0.352 12.6232 0 14.4979 0 16.455C0 18.4122 0.352 20.2869 0.995188 22.0202H31.0049C31.648 20.2869 32 18.4122 32 16.455C32 14.4979 31.648 12.6232 31.0048 10.8899Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 0.455078C11.1502 0.455078 6.80504 2.61283 3.87085 6.02027H28.1284C25.1943 2.61283 20.8491 0.455078 15.9997 0.455078V0.455078Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1285 26.8899H3.87085C6.80504 30.2973 11.1502 32.4551 15.9997 32.4551C20.8491 32.4551 25.1943 30.2973 28.1285 26.8899Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.455078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThailand);
export default __webpack_public_path__ + "static/media/thailand.3acba070.svg";
export { ForwardRef as ReactComponent };